import { DetailsContent } from '@digdir/designsystemet-react';

import styled from '../../../../../../styled';

export const SamtykkeRadioWrapper = styled.div`
  gap: var(--ds-size-8);
  margin-bottom: var(--ds-size-6);
`;

export const ContentWrapper = styled.div`
  display: contents;
`;

export const StyledDetailsContent = styled(DetailsContent)`
  margin-top: var(--ds-size-8);
`;
